<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <div class="name">
                  <h3 class="title">精选海鲜牛排</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              加拿大跨境海鲜,大陆地区免费配送上门，给远在中国的亲朋好友送上专属于枫叶国的“至鲜”问候。
              我们的产品从产地源头鲜捕，零下21℃鲜冻，产地精选鲜供，是馈赠亲友、员工福利、家庭自用的首选佳品。
            </p>
          </div>
          <ProductGallery class="products" :products="productList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProductGallery from "@/components/products/ProductGallery.vue";
import { Tabs } from "@/components";
export default {
  name: "Seafood",
  components: {
    Tabs,
    ProductGallery
  },
  bodyClass: "profile-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bgs/seafoodBG.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/seafood.png")
    }
  },
  computed: {
    ...mapGetters(["products"]),
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },
    productList() {
      return this.products.filter(item => item.product_category === 3);
    },
  },
  methods: {
    ...mapActions(["listProducts"])
  },
  mounted() {
    if (!this.products.length) {
      this.listProducts();
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.products {
  padding-bottom: 4rem;
}


</style>
